import { render } from "./carte-e-servizi.vue?vue&type=template&id=34f174de&bindings={\"transitionName\":\"options\"}"
import script from "./carte-e-servizi.vue?vue&type=script&lang=js"
export * from "./carte-e-servizi.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./carte-e-servizi.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script